module.exports = __webpack_public_path__ + "school/img/ketijieshao2.d19a2b11.jpg";